/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One rendered dashboard widget handed to the dashboard agent for analysis.
 * 
 * Serialized by the frontend from the rendered dashboard tree. ``content`` is the
 * opaque rendered payload (e.g. a LineChart's series) the agent reads read-only via
 * its ``get_widget_data`` tool; ``id`` is the widget id a ``widget://<id>`` link
 * refers to. ``title``/``metric_name`` are the lightweight manifest the agent sees in
 * context (so it knows what exists without loading every series).
 * @export
 * @interface DashboardWidget
 */
export interface DashboardWidget {
    /**
     * 
     * @type {string}
     * @memberof DashboardWidget
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardWidget
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardWidget
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardWidget
     */
    metricName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof DashboardWidget
     */
    content?: any | null;
}

/**
 * Check if a given object implements the DashboardWidget interface.
 */
export function instanceOfDashboardWidget(value: object): value is DashboardWidget {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function DashboardWidgetFromJSON(json: any): DashboardWidget {
    return DashboardWidgetFromJSONTyped(json, false);
}

export function DashboardWidgetFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardWidget {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'title': json['title'] == null ? undefined : json['title'],
        'metricName': json['metric_name'] == null ? undefined : json['metric_name'],
        'content': json['content'] == null ? undefined : json['content'],
    };
}

export function DashboardWidgetToJSON(json: any): DashboardWidget {
    return DashboardWidgetToJSONTyped(json, false);
}

export function DashboardWidgetToJSONTyped(value?: DashboardWidget | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'title': value['title'],
        'metric_name': value['metricName'],
        'content': value['content'],
    };
}

